import React from 'react';

import { connect } from 'react-redux';
import { auth } from '../../firebase';
import { navigateTop } from '../routing/router-utils';
import { formatPhoneNumber } from 'react-phone-number-input'
import useIntercomLogging from '../intercom/useIntercomLogging';
import CurrentTimeProvider from '../timeSlots/CurrentTimeProvider';
import DeliverySlotsProvider from '../timeSlots/DeliverySlotsProvider';
import DisplayDeliverySlots from '../timeSlots/DisplayDeliverySlots';
import OrderTypeToggle from '../common/OrderTypeToggle';
import PlaceOrderItems from './PlaceOrderItems';
import DisplayBulkDiscount from './DisplayBulkDiscount';
import OrderDeliveryButton from './OrderDeliveryButton';
import ErrorBoundary from '../common/ErrorBoundary';
import PropTypes from 'prop-types';

import styles from './PlaceOrder.module.css';

/**
 * Place Order - Delivery
 * TODO: Need to add the delivery zip code check
 * TODO: Disable Aeropay 
 */
const PlaceOrder = ({
  dispensaryId /* from controller via url */, 
  dispensaryName,
  minDeliveryOrder,
  dispensaryLogoPath,
  isPickup,
  handlePickupClick,
  delivery_address={}, 
  tel_number,
  itemTotal 
}) => {

  const [noDiscountFound, setNoDiscountFound] = React.useState();

  const OrderSection = ({title, children}) => {
    return (
      <div className={styles.section}>
        { title && (
          <div className={styles.sectionTitle}>{title}</div>
        )}
        <div className={styles.sectionInner}>
          {children}
        </div>
      </div>
    );
  }
  
  const { street_address, apartment_number, city, state, zip_code } = delivery_address;
  const displayApartmentNumber = apartment_number ? `${' '}${apartment_number}`: '';

   // Ensure bulk discount recalc
   React.useEffect(() => {
     setNoDiscountFound(false);  
   }, [itemTotal]);

  // Track user starting checkout
  useIntercomLogging(auth.currentUser, 'Checkout_Delivery', true);

  return (
    <>
      <OrderSection>
        <div className={styles.logoWrap}>
          { dispensaryLogoPath &&
            <img className={styles.logo} alt="" height="30" src={dispensaryLogoPath} />
          }
          <div className={styles.dispensaryName}>
            <div className={styles.orderFrom}>ORDER FROM</div>
            <div className={styles.orderStore} onClick={() => {navigateTop(`/dispensary/${dispensaryId}`)}}>
              {dispensaryName}
            </div>
          </div>
        </div>
      </OrderSection>
  
      <OrderSection title="METHOD">
        <OrderTypeToggle inBody isPickup={isPickup} handlePickupClick={handlePickupClick} />
      </OrderSection>
      
      <OrderSection title="TIME">
        <ErrorBoundary>
          <CurrentTimeProvider>
            <DeliverySlotsProvider dispensaryId={dispensaryId}>
              <DisplayDeliverySlots dispensaryId={dispensaryId} dispensaryName={dispensaryName} />
            </DeliverySlotsProvider>
          </CurrentTimeProvider>
        </ErrorBoundary>
      </OrderSection>
      
      <OrderSection title="ADDRESS">
        <span>
          { street_address &&
            `${street_address}${displayApartmentNumber}, ${city}, ${state}, ${zip_code}`
          }
        </span>
      </OrderSection>
      
      <OrderSection title="PHONE NUMBER">
         <span>{formatPhoneNumber(tel_number)}</span>
      </OrderSection>
      
      <OrderSection title="SUMMARY">
        <PlaceOrderItems />
      </OrderSection>
      
      { !noDiscountFound &&
        <OrderSection title="BULK DISCOUNTS">
          <DisplayBulkDiscount handleNoDiscount={setNoDiscountFound} />
        </OrderSection>
      }
      
      <OrderSection>
        {/* TODO - do another zip code check here */}
        <OrderDeliveryButton
          dispensaryId={dispensaryId}
          dispensaryName={dispensaryName}
          minDeliveryOrder={minDeliveryOrder} />
      </OrderSection>
    </>
  )
}

PlaceOrder.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  minDeliveryOrder: PropTypes.number.isRequired,
  dispensaryLogoPath: PropTypes.string,
  isPickup: PropTypes.bool.isRequired,
  handlePickupClick: PropTypes.func.isRequired,
  /* from redux */
  delivery_address: PropTypes.object.isRequired,
  tel_number: PropTypes.string.isRequired,
  itemTotal: PropTypes.number.isRequired
};

const mapStateToProps = (state) => {
  return {
    delivery_address: state.delivery_address,
    tel_number: state.tel_number,
    itemTotal: state.total
  }
}

export default connect(mapStateToProps)(PlaceOrder);